<template>
  <div class="dm-body">
    <template>
      <DogForm />
    </template>
  </div>
</template>

<script>
  import DogForm from '../components/dogs/DogForm.vue'

  export default {
    data() {
      return {
          //showLogin: true
      }
    },
    computed: {
      /*...mapGetters({
          // map `this.user` to `this.$store.getters.user`
          user: "user"
      })*/
    },
    components: {
      /*Signup,
      Login,
      Dashboard,
      UserProfile*/
      DogForm
    },
    methods: {
      /*resetPwd() {
        alert('Funzione da rilasciare a breve ...')
        return 
      }*/
    }
  };
</script>

<style>
.dm-body {
  text-align: center;
  padding: 20px 0;
}
.linkable {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
</style>